import React from 'react';
import PropTypes from 'prop-types';
import { AssetCard } from '../AssetCard';

const DraggableAssetCard = ({ question, isReadOnly = false }) => (
  <AssetCard question={question} isReadOnly={isReadOnly} />
);

DraggableAssetCard.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  isReadOnly: PropTypes.bool
};

export { DraggableAssetCard };
